import { Routes, Route } from "react-router-dom";
import { CampaignsList } from "./index";
import { CreateCampaign } from "./create";
import { EditCampaign } from "./edit";
import { CampaignProductsPage } from "./products";

export default function CampaignsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CampaignsList />} />
      <Route path="/create" element={<CreateCampaign />} />
      <Route path="/:type/:code/edit" element={<EditCampaign />} />
      <Route path="/:type/:code/produtos" element={<CampaignProductsPage />} />
    </Routes>
  );
}
